module.exports = __webpack_public_path__ + "static/favicon-b26759499ce0ae694e3654e95212b1c1.ico";